import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Query = {
  __typename?: 'Query';
  getAllDocuments: PaginatedDocuments;
  document?: Maybe<Document>;
  me?: Maybe<User>;
  user?: Maybe<User>;
  groupAncestors: Array<Group>;
  group?: Maybe<Group>;
  getDescendants: Array<Group>;
  getChild: Array<Group>;
  generateResult: Scalars['String'];
  documentType: DocumentType;
  documentTypesByParentId: Array<DocumentType>;
};


export type QueryGetAllDocumentsArgs = {
  cursor?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


export type QueryDocumentArgs = {
  id: Scalars['Int'];
};


export type QueryUserArgs = {
  id: Scalars['String'];
};


export type QueryGroupAncestorsArgs = {
  groupId: Scalars['Float'];
};


export type QueryGroupArgs = {
  id: Scalars['Float'];
};


export type QueryGetDescendantsArgs = {
  groupId: Scalars['Float'];
};


export type QueryGetChildArgs = {
  groupId: Scalars['Float'];
};


export type QueryGenerateResultArgs = {
  groupId: Scalars['Float'];
};


export type QueryDocumentTypeArgs = {
  id: Scalars['Float'];
};


export type QueryDocumentTypesByParentIdArgs = {
  parentId?: Maybe<Scalars['Float']>;
};

export type PaginatedDocuments = {
  __typename?: 'PaginatedDocuments';
  array: Array<Document>;
  hasMore: Scalars['Boolean'];
};

export type Document = {
  __typename?: 'Document';
  id: Scalars['Float'];
  text: Scalars['String'];
  documentTypeId: Scalars['Float'];
  status: Scalars['Float'];
  documentType?: Maybe<DocumentType>;
  attachmentIds?: Maybe<Array<Scalars['Int']>>;
  attachments?: Maybe<Array<Attachment>>;
  educationalYear: Scalars['Float'];
  additionalField?: Maybe<Scalars['String']>;
  archivedValue?: Maybe<Scalars['String']>;
  semester: Scalars['Float'];
  archived?: Maybe<Scalars['Boolean']>;
  moderatorId?: Maybe<Scalars['String']>;
  moderator?: Maybe<User>;
  creatorId: Scalars['String'];
  creator: User;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  textSnippet: Scalars['String'];
};

export type DocumentType = {
  __typename?: 'DocumentType';
  id: Scalars['Float'];
  name: Scalars['String'];
  values?: Maybe<Scalars['String']>;
  limits?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentForModerator?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  isCategory?: Maybe<Scalars['Boolean']>;
  valuesNames?: Maybe<Array<Scalars['String']>>;
  children: Array<DocumentType>;
  additionalFields?: Maybe<Scalars['String']>;
  creatorId: Scalars['String'];
  documents: Array<Document>;
  path: Array<DocumentType>;
  editorId: Scalars['String'];
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['Float'];
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  storage: Scalars['String'];
  type: Scalars['String'];
  creatorId: Scalars['String'];
  creator: User;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  departmentName: Scalars['String'];
  universityDegree?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  moderator: Scalars['Boolean'];
  admin: Scalars['Boolean'];
  group: Group;
  documents?: Maybe<Array<Document>>;
  moderatedDocuments?: Maybe<Array<Document>>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  statuses: Statuses;
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['Float'];
  name: Scalars['String'];
  departmentName: Scalars['String'];
  users?: Maybe<Array<User>>;
  startYear?: Maybe<Scalars['Float']>;
  children: Array<Group>;
  archived: Scalars['Boolean'];
  creatorId: Scalars['String'];
  isFinal?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
  statuses: Statuses;
};

export type Statuses = {
  __typename?: 'Statuses';
  status0: Scalars['Float'];
  status1: Scalars['Float'];
  status2: Scalars['Float'];
  status3: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createDocument: Document;
  updateDocument: Document;
  updateStatus: Scalars['Boolean'];
  updatePost?: Maybe<Document>;
  deleteDocument: Scalars['Boolean'];
  login?: Maybe<Scalars['String']>;
  updateUserGroup?: Maybe<Scalars['Boolean']>;
  updateGroup?: Maybe<Scalars['String']>;
  logout: Scalars['Boolean'];
  createGroup: Group;
  createDocumentType: DocumentType;
  editDocumentType: DocumentType;
  deleteDocumentType: DocumentType;
};


export type MutationCreateDocumentArgs = {
  input: DocumentInput;
};


export type MutationUpdateDocumentArgs = {
  input: DocumentInput;
  id: Scalars['Int'];
};


export type MutationUpdateStatusArgs = {
  status: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationUpdatePostArgs = {
  text: Scalars['String'];
  id: Scalars['Int'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationLoginArgs = {
  isMobile: Scalars['Boolean'];
  redirectUri: Scalars['String'];
  code_verifier: Scalars['String'];
  code: Scalars['String'];
};


export type MutationUpdateUserGroupArgs = {
  id: Scalars['Float'];
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateDocumentTypeArgs = {
  input: CreateDocumentTypeInput;
};


export type MutationEditDocumentTypeArgs = {
  input: EditDocumentTypeInput;
};


export type MutationDeleteDocumentTypeArgs = {
  id: Scalars['Float'];
};

export type DocumentInput = {
  text: Scalars['String'];
  documentTypeId: Scalars['Float'];
  attachmentIds?: Maybe<Array<Scalars['String']>>;
  additionalField?: Maybe<Scalars['String']>;
};

export type CreateGroupInput = {
  name: Scalars['String'];
  departmentName?: Maybe<Scalars['String']>;
  startYear?: Maybe<Scalars['Float']>;
  parentId: Scalars['Float'];
  archived?: Maybe<Scalars['Boolean']>;
};

export type CreateDocumentTypeInput = {
  name: Scalars['String'];
  values?: Maybe<Scalars['String']>;
  limits?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentForModerator?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  isCategory?: Maybe<Scalars['Boolean']>;
  parentId: Scalars['Float'];
  additionalFields?: Maybe<Scalars['String']>;
};

export type EditDocumentTypeInput = {
  name?: Maybe<Scalars['String']>;
  values?: Maybe<Scalars['String']>;
  limits?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentForModerator?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  isCategory?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['Float']>;
  additionalFields?: Maybe<Scalars['String']>;
};

export type CreateDocumentMutationVariables = Exact<{
  input: DocumentInput;
}>;


export type CreateDocumentMutation = (
  { __typename?: 'Mutation' }
  & { createDocument: (
    { __typename?: 'Document' }
    & Pick<Document, 'text'>
  ) }
);

export type UpdateDocumentMutationVariables = Exact<{
  input: DocumentInput;
  id: Scalars['Int'];
}>;


export type UpdateDocumentMutation = (
  { __typename?: 'Mutation' }
  & { updateDocument: (
    { __typename?: 'Document' }
    & Pick<Document, 'id'>
  ) }
);

export type CreateDocumentTypeMutationVariables = Exact<{
  input: CreateDocumentTypeInput;
}>;


export type CreateDocumentTypeMutation = (
  { __typename?: 'Mutation' }
  & { createDocumentType: (
    { __typename?: 'DocumentType' }
    & Pick<DocumentType, 'name' | 'id'>
  ) }
);

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteDocumentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteDocument'>
);

export type LoginMutationVariables = Exact<{
  code: Scalars['String'];
  code_verifier: Scalars['String'];
  redirectUri: Scalars['String'];
  isMobile: Scalars['Boolean'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'login'>
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type UpdateStatusMutationVariables = Exact<{
  id: Scalars['Int'];
  status: Scalars['Int'];
}>;


export type UpdateStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateStatus'>
);

export type UpdateUserGroupMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type UpdateUserGroupMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateUserGroup'>
);

export type DocumentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DocumentQuery = (
  { __typename?: 'Query' }
  & { document?: Maybe<(
    { __typename?: 'Document' }
    & Pick<Document, 'text' | 'documentTypeId' | 'attachmentIds' | 'archived' | 'updatedAt' | 'createdAt' | 'status' | 'additionalField' | 'educationalYear' | 'id' | 'creatorId'>
    & { documentType?: Maybe<(
      { __typename?: 'DocumentType' }
      & Pick<DocumentType, 'name' | 'values'>
    )>, attachments?: Maybe<Array<(
      { __typename?: 'Attachment' }
      & Pick<Attachment, 'id' | 'name' | 'storage' | 'type' | 'url'>
    )>> }
  )> }
);

export type DocumentTypeQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type DocumentTypeQuery = (
  { __typename?: 'Query' }
  & { documentType: (
    { __typename?: 'DocumentType' }
    & Pick<DocumentType, 'id' | 'name' | 'values' | 'limits' | 'additionalFields' | 'isCategory'>
    & { path: Array<(
      { __typename?: 'DocumentType' }
      & Pick<DocumentType, 'name' | 'id' | 'valuesNames'>
    )>, children: Array<(
      { __typename?: 'DocumentType' }
      & Pick<DocumentType, 'name' | 'isCategory' | 'id'>
    )> }
  ) }
);

export type GenerateResultQueryVariables = Exact<{
  groupId: Scalars['Float'];
}>;


export type GenerateResultQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'generateResult'>
);

export type GroupQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type GroupQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'Group' }
    & Pick<Group, 'id' | 'name'>
    & { users?: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'name' | 'id'>
    )>>, children: Array<(
      { __typename?: 'Group' }
      & Pick<Group, 'name' | 'id' | 'startYear' | 'isFinal'>
    )> }
  )> }
);

export type GroupAncestorsQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type GroupAncestorsQuery = (
  { __typename?: 'Query' }
  & { groupAncestors: Array<(
    { __typename?: 'Group' }
    & Pick<Group, 'name' | 'id' | 'isFinal'>
  )> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'email' | 'name' | 'createdAt' | 'updatedAt' | 'universityDegree' | 'groupId' | 'moderator' | 'admin'>
  )> }
);

export type ModerationDashboardQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type ModerationDashboardQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'Group' }
    & Pick<Group, 'id' | 'name'>
  )> }
);

export type ModerationGroupQueryVariables = Exact<{
  id: Scalars['Float'];
}>;


export type ModerationGroupQuery = (
  { __typename?: 'Query' }
  & { group?: Maybe<(
    { __typename?: 'Group' }
    & Pick<Group, 'id' | 'name'>
    & { users?: Maybe<Array<(
      { __typename?: 'User' }
      & Pick<User, 'name' | 'id' | 'moderator'>
      & { statuses: (
        { __typename?: 'Statuses' }
        & Pick<Statuses, 'status0' | 'status1' | 'status2' | 'status3'>
      ) }
    )>>, children: Array<(
      { __typename?: 'Group' }
      & Pick<Group, 'name' | 'id' | 'startYear' | 'isFinal'>
    )> }
  )> }
);

export type MyDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyDocumentsQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { documents?: Maybe<Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'attachmentIds' | 'text' | 'createdAt' | 'updatedAt' | 'id' | 'status' | 'documentTypeId'>
      & { documentType?: Maybe<(
        { __typename?: 'DocumentType' }
        & Pick<DocumentType, 'name' | 'values'>
      )> }
    )>> }
  )> }
);

export type UserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'name' | 'email' | 'id' | 'groupId' | 'createdAt'>
    & { group: (
      { __typename?: 'Group' }
      & Pick<Group, 'name'>
    ), documents?: Maybe<Array<(
      { __typename?: 'Document' }
      & Pick<Document, 'id' | 'text' | 'createdAt' | 'updatedAt' | 'status'>
      & { documentType?: Maybe<(
        { __typename?: 'DocumentType' }
        & Pick<DocumentType, 'name' | 'values'>
      )> }
    )>> }
  )> }
);


export const CreateDocumentDocument = gql`
    mutation CreateDocument($input: DocumentInput!) {
  createDocument(input: $input) {
    text
  }
}
    `;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, baseOptions);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($input: DocumentInput!, $id: Int!) {
  updateDocument(input: $input, id: $id) {
    id
  }
}
    `;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, baseOptions);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const CreateDocumentTypeDocument = gql`
    mutation CreateDocumentType($input: createDocumentTypeInput!) {
  createDocumentType(input: $input) {
    name
    id
  }
}
    `;
export type CreateDocumentTypeMutationFn = Apollo.MutationFunction<CreateDocumentTypeMutation, CreateDocumentTypeMutationVariables>;

/**
 * __useCreateDocumentTypeMutation__
 *
 * To run a mutation, you first call `useCreateDocumentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentTypeMutation, { data, loading, error }] = useCreateDocumentTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentTypeMutation, CreateDocumentTypeMutationVariables>) {
        return Apollo.useMutation<CreateDocumentTypeMutation, CreateDocumentTypeMutationVariables>(CreateDocumentTypeDocument, baseOptions);
      }
export type CreateDocumentTypeMutationHookResult = ReturnType<typeof useCreateDocumentTypeMutation>;
export type CreateDocumentTypeMutationResult = Apollo.MutationResult<CreateDocumentTypeMutation>;
export type CreateDocumentTypeMutationOptions = Apollo.BaseMutationOptions<CreateDocumentTypeMutation, CreateDocumentTypeMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($id: Int!) {
  deleteDocument(id: $id)
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, baseOptions);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const LoginDocument = gql`
    mutation login($code: String!, $code_verifier: String!, $redirectUri: String!, $isMobile: Boolean!) {
  login(code: $code, code_verifier: $code_verifier, redirectUri: $redirectUri, isMobile: $isMobile)
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      code: // value for 'code'
 *      code_verifier: // value for 'code_verifier'
 *      redirectUri: // value for 'redirectUri'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, baseOptions);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const UpdateStatusDocument = gql`
    mutation updateStatus($id: Int!, $status: Int!) {
  updateStatus(id: $id, status: $status)
}
    `;
export type UpdateStatusMutationFn = Apollo.MutationFunction<UpdateStatusMutation, UpdateStatusMutationVariables>;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusMutation, UpdateStatusMutationVariables>) {
        return Apollo.useMutation<UpdateStatusMutation, UpdateStatusMutationVariables>(UpdateStatusDocument, baseOptions);
      }
export type UpdateStatusMutationHookResult = ReturnType<typeof useUpdateStatusMutation>;
export type UpdateStatusMutationResult = Apollo.MutationResult<UpdateStatusMutation>;
export type UpdateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const UpdateUserGroupDocument = gql`
    mutation updateUserGroup($id: Float!) {
  updateUserGroup(id: $id)
}
    `;
export type UpdateUserGroupMutationFn = Apollo.MutationFunction<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;

/**
 * __useUpdateUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGroupMutation, { data, loading, error }] = useUpdateUserGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>) {
        return Apollo.useMutation<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>(UpdateUserGroupDocument, baseOptions);
      }
export type UpdateUserGroupMutationHookResult = ReturnType<typeof useUpdateUserGroupMutation>;
export type UpdateUserGroupMutationResult = Apollo.MutationResult<UpdateUserGroupMutation>;
export type UpdateUserGroupMutationOptions = Apollo.BaseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const DocumentDocument = gql`
    query document($id: Int!) {
  document(id: $id) {
    text
    documentType {
      name
      values
    }
    documentTypeId
    attachmentIds
    archived
    updatedAt
    createdAt
    status
    additionalField
    educationalYear
    id
    creatorId
    attachments {
      id
      name
      storage
      type
      url
    }
  }
}
    `;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions?: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, baseOptions);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, baseOptions);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const DocumentTypeDocument = gql`
    query documentType($id: Float!) {
  documentType(id: $id) {
    id
    name
    values
    limits
    values
    additionalFields
    path {
      name
      id
      valuesNames
    }
    isCategory
    children {
      name
      isCategory
      id
    }
  }
}
    `;

/**
 * __useDocumentTypeQuery__
 *
 * To run a query within a React component, call `useDocumentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentTypeQuery(baseOptions?: Apollo.QueryHookOptions<DocumentTypeQuery, DocumentTypeQueryVariables>) {
        return Apollo.useQuery<DocumentTypeQuery, DocumentTypeQueryVariables>(DocumentTypeDocument, baseOptions);
      }
export function useDocumentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentTypeQuery, DocumentTypeQueryVariables>) {
          return Apollo.useLazyQuery<DocumentTypeQuery, DocumentTypeQueryVariables>(DocumentTypeDocument, baseOptions);
        }
export type DocumentTypeQueryHookResult = ReturnType<typeof useDocumentTypeQuery>;
export type DocumentTypeLazyQueryHookResult = ReturnType<typeof useDocumentTypeLazyQuery>;
export type DocumentTypeQueryResult = Apollo.QueryResult<DocumentTypeQuery, DocumentTypeQueryVariables>;
export const GenerateResultDocument = gql`
    query generateResult($groupId: Float!) {
  generateResult(groupId: $groupId)
}
    `;

/**
 * __useGenerateResultQuery__
 *
 * To run a query within a React component, call `useGenerateResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateResultQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGenerateResultQuery(baseOptions?: Apollo.QueryHookOptions<GenerateResultQuery, GenerateResultQueryVariables>) {
        return Apollo.useQuery<GenerateResultQuery, GenerateResultQueryVariables>(GenerateResultDocument, baseOptions);
      }
export function useGenerateResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateResultQuery, GenerateResultQueryVariables>) {
          return Apollo.useLazyQuery<GenerateResultQuery, GenerateResultQueryVariables>(GenerateResultDocument, baseOptions);
        }
export type GenerateResultQueryHookResult = ReturnType<typeof useGenerateResultQuery>;
export type GenerateResultLazyQueryHookResult = ReturnType<typeof useGenerateResultLazyQuery>;
export type GenerateResultQueryResult = Apollo.QueryResult<GenerateResultQuery, GenerateResultQueryVariables>;
export const GroupDocument = gql`
    query group($id: Float!) {
  group(id: $id) {
    id
    name
    users {
      name
      id
    }
    children {
      name
      id
      startYear
      isFinal
    }
  }
}
    `;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupQuery(baseOptions?: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables>) {
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, baseOptions);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, baseOptions);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const GroupAncestorsDocument = gql`
    query groupAncestors($id: Float!) {
  groupAncestors(groupId: $id) {
    name
    id
    isFinal
  }
}
    `;

/**
 * __useGroupAncestorsQuery__
 *
 * To run a query within a React component, call `useGroupAncestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupAncestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAncestorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupAncestorsQuery(baseOptions?: Apollo.QueryHookOptions<GroupAncestorsQuery, GroupAncestorsQueryVariables>) {
        return Apollo.useQuery<GroupAncestorsQuery, GroupAncestorsQueryVariables>(GroupAncestorsDocument, baseOptions);
      }
export function useGroupAncestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupAncestorsQuery, GroupAncestorsQueryVariables>) {
          return Apollo.useLazyQuery<GroupAncestorsQuery, GroupAncestorsQueryVariables>(GroupAncestorsDocument, baseOptions);
        }
export type GroupAncestorsQueryHookResult = ReturnType<typeof useGroupAncestorsQuery>;
export type GroupAncestorsLazyQueryHookResult = ReturnType<typeof useGroupAncestorsLazyQuery>;
export type GroupAncestorsQueryResult = Apollo.QueryResult<GroupAncestorsQuery, GroupAncestorsQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    name
    createdAt
    updatedAt
    universityDegree
    groupId
    moderator
    admin
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const ModerationDashboardDocument = gql`
    query moderationDashboard($id: Float!) {
  group(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useModerationDashboardQuery__
 *
 * To run a query within a React component, call `useModerationDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useModerationDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModerationDashboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModerationDashboardQuery(baseOptions?: Apollo.QueryHookOptions<ModerationDashboardQuery, ModerationDashboardQueryVariables>) {
        return Apollo.useQuery<ModerationDashboardQuery, ModerationDashboardQueryVariables>(ModerationDashboardDocument, baseOptions);
      }
export function useModerationDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModerationDashboardQuery, ModerationDashboardQueryVariables>) {
          return Apollo.useLazyQuery<ModerationDashboardQuery, ModerationDashboardQueryVariables>(ModerationDashboardDocument, baseOptions);
        }
export type ModerationDashboardQueryHookResult = ReturnType<typeof useModerationDashboardQuery>;
export type ModerationDashboardLazyQueryHookResult = ReturnType<typeof useModerationDashboardLazyQuery>;
export type ModerationDashboardQueryResult = Apollo.QueryResult<ModerationDashboardQuery, ModerationDashboardQueryVariables>;
export const ModerationGroupDocument = gql`
    query moderationGroup($id: Float!) {
  group(id: $id) {
    id
    name
    users {
      name
      id
      statuses {
        status0
        status1
        status2
        status3
      }
      moderator
    }
    children {
      name
      id
      startYear
      isFinal
    }
  }
}
    `;

/**
 * __useModerationGroupQuery__
 *
 * To run a query within a React component, call `useModerationGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useModerationGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModerationGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useModerationGroupQuery(baseOptions?: Apollo.QueryHookOptions<ModerationGroupQuery, ModerationGroupQueryVariables>) {
        return Apollo.useQuery<ModerationGroupQuery, ModerationGroupQueryVariables>(ModerationGroupDocument, baseOptions);
      }
export function useModerationGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModerationGroupQuery, ModerationGroupQueryVariables>) {
          return Apollo.useLazyQuery<ModerationGroupQuery, ModerationGroupQueryVariables>(ModerationGroupDocument, baseOptions);
        }
export type ModerationGroupQueryHookResult = ReturnType<typeof useModerationGroupQuery>;
export type ModerationGroupLazyQueryHookResult = ReturnType<typeof useModerationGroupLazyQuery>;
export type ModerationGroupQueryResult = Apollo.QueryResult<ModerationGroupQuery, ModerationGroupQueryVariables>;
export const MyDocumentsDocument = gql`
    query MyDocuments {
  me {
    id
    documents {
      attachmentIds
      text
      createdAt
      updatedAt
      id
      status
      documentTypeId
      documentType {
        name
        values
      }
    }
  }
}
    `;

/**
 * __useMyDocumentsQuery__
 *
 * To run a query within a React component, call `useMyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<MyDocumentsQuery, MyDocumentsQueryVariables>) {
        return Apollo.useQuery<MyDocumentsQuery, MyDocumentsQueryVariables>(MyDocumentsDocument, baseOptions);
      }
export function useMyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDocumentsQuery, MyDocumentsQueryVariables>) {
          return Apollo.useLazyQuery<MyDocumentsQuery, MyDocumentsQueryVariables>(MyDocumentsDocument, baseOptions);
        }
export type MyDocumentsQueryHookResult = ReturnType<typeof useMyDocumentsQuery>;
export type MyDocumentsLazyQueryHookResult = ReturnType<typeof useMyDocumentsLazyQuery>;
export type MyDocumentsQueryResult = Apollo.QueryResult<MyDocumentsQuery, MyDocumentsQueryVariables>;
export const UserDocument = gql`
    query user($id: String!) {
  user(id: $id) {
    name
    email
    id
    groupId
    createdAt
    group {
      name
    }
    documents {
      id
      text
      createdAt
      updatedAt
      status
      documentType {
        name
        values
      }
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, baseOptions);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, baseOptions);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;